export default __webpack_public_path__ + "static/media/book cover - front.3aad5226.png";